import { IApplicationState } from '../../types/redux';

export const selectSubmittedAnketaModalListNumber = (state: IApplicationState): number | null =>
  state.calculator.submittedAnketaModal.listNumber;
